// src/api/vaultApi.js
import { createAuthenticatedClient } from "./http";
import config from "../config"; // must export: { SERVER_URL: "http://localhost:3000" } etc.

const api = createAuthenticatedClient({
    baseURL: `${config.SERVER_URL}/api/vault`,
});

// Attach auth token like the rest of your app
api.interceptors.request.use((cfg) => {
    const token = localStorage.getItem("token");
    if (token) cfg.headers.Authorization = `Bearer ${token}`;
    return cfg;
});

// ---- API calls ----
export async function listDocs({ slotKey } = {}) {
    const { data } = await api.get("/docs", { params: { slotKey } });
    return data.docs || [];
}

export async function uploadDocs({ files, slotKey = null, displayName = null, expiresAt = null, makeCurrent = true }) {
    const fd = new FormData();
    Array.from(files).forEach((f) => fd.append("files", f));
    if (slotKey) fd.append("slotKey", slotKey);
    if (displayName) fd.append("displayName", displayName);
    if (expiresAt) fd.append("expiresAt", expiresAt); // ISO string
    if (slotKey) fd.append("makeCurrent", String(makeCurrent));
    const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
    return data.uploaded || [];
}

export async function patchDoc(id, { displayName, expiresAt, slotKey, makeCurrent } = {}) {
    const body = {};
    if (displayName !== undefined) body.displayName = displayName;
    if (expiresAt !== undefined) body.expiresAt = expiresAt; // ISO or null
    if (slotKey !== undefined) body.slotKey = slotKey;
    if (makeCurrent !== undefined) body.makeCurrent = makeCurrent;
    await api.patch(`/docs/${id}`, body);
}

export async function deleteDoc(id) {
    await api.delete(`/docs/${id}`);
}

export async function downloadDoc(id, { delivery = "browser", to } = {}) {
    const { data } = await api.post(`/docs/${id}/download`, { delivery, to });
    return data; // { url } or { ok:true, delivered:"email" }
}

export async function sendDocumentSecurely(docId, { recipientEmail, message, encrypted, expiresInDays, requireVerification }) {
    const { data } = await api.post(`/docs/${docId}/send-secure`, {
        recipientEmail,
        message,
        encrypted,
        expiresInDays,
        requireVerification
    });
    return data;
}

// Public endpoints for shared documents (no auth required)
export async function getSharedDocInfo(token) {
    const { data } = await api.get(`/shared/${token}`);
    return data;
}

export async function verifySharedDoc(token, code) {
    const { data } = await api.post(`/shared/${token}/verify`, { code });
    return data;
}

export async function downloadSharedDoc(token) {
    const { data } = await api.post(`/shared/${token}/download`);
    return data;
}
